import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export type UserMenuRoute =
  | 'AssortmentManager'
  | 'BasketManager'
  | 'BusinessContacts'
  | 'ChangePassword'
  | 'MainUserMenu'
  | 'UserAccounts'
  | 'UserContacts';
@Injectable()
export class UserMenuRouterService {
  public routerState$ = new BehaviorSubject<UserMenuRoute>('MainUserMenu');

  public go(route: UserMenuRoute) {
    this.routerState$.next(route);
  }
}
